import BaseModel from '@/orm/models/BaseModel';

export default class CountryCurrency extends BaseModel {
  static entity = 'countryCurrency';

  static primaryKey = ['countryId', 'currencyId'];

  static fields() {
    return {
      countryId: this.attr(null),
      currencyId: this.attr(null),
    };
  }

  static apiConfig = {}
}
